<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.seniority.level.title')"
        data-testid="admin-section-tabs-qualification-seniority-level"
    >
        <VJoySelect
            v-if="profileQualificationStore.inEditMode"
            :model-value="internalSeniorityLevelAsString"
            data-testid="vetting-internal-seniority-level-edition"
            @change="(event: any) => (profileQualificationStore.qualificationUpdateForm.internalSeniorityLevel = Number(event.target.value))"
        >
            <option value="1">{{ $t('profile.vetting.qualification.seniority.level.select.level.one') }}</option>
            <option value="2">{{ $t('profile.vetting.qualification.seniority.level.select.level.two') }}</option>
            <option value="3">{{ $t('profile.vetting.qualification.seniority.level.select.level.three') }}</option>
            <option value="4">{{ $t('profile.vetting.qualification.seniority.level.select.level.four') }}</option>
            <option value="5">{{ $t('profile.vetting.qualification.seniority.level.select.level.five') }}</option>
        </VJoySelect>
        <template v-else>
            <TextField
                v-if="profileQualificationStore.qualificationUpdateForm.internalSeniorityLevel"
                :content="'Level ' + profileQualificationStore.qualificationUpdateForm.internalSeniorityLevel"
                data-testid="vetting-internal-seniority-level-set"
            />
            <TextField v-else :content="$t('profile.vetting.qualification.seniority.level.selected.placeholder')" />
        </template>
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoySelect} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const internalSeniorityLevelAsString = computed(() => {
        return profileQualificationStore.qualificationUpdateForm.internalSeniorityLevel?.toString() ?? '';
    });
</script>
